import { createEditorState } from 'medium-draft';
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import classNames from 'classnames';
import moment from 'moment';
import {
  FormattedMessage,
  FormattedHTMLMessage,
  intlShape,
  injectIntl,
} from 'react-intl';
import {
  reduxForm,
  Field,
  propTypes as reduxFormPropTypes,
  submit,
} from 'redux-form';
import LoadingBar from 'react-redux-loading-bar';

import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import Typography from '@material-ui/core/Typography';
import LinearProgress from '@material-ui/core/LinearProgress';
import Slide from '@material-ui/core/Slide';

import NextIcon from '@material-ui/icons/NavigateNext';
import { stateToHTML } from 'draft-js-export-html';
import { Interweave } from 'interweave';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import { getCourseBySlug } from '../../../actions/courseDetails';
import CircularProgressLoader from '../../../components/CircularProgressLoader/CircularProgressLoader';
import Intercom from '../../../widgets/Intercom';
import entityStyleFn from './entityStyleFn';
import s from './ViewQuiz.scss';
import * as quizResultActions from '../../../actions/quizResult';
import QuestionsForm from './questionsForm/QuestionsForm';
import Link from '../../../components/Link/Link';
import { startQuiz, resetQuiz } from '../../../actions/viewQuiz';
import SectionItemNavigationMenu from '../../../components/SectionItemNavigationMenu/SectionItemNavigationMenu';
import TextField from '../../../components/statelessComponents/FormFields/TextField';
import messages from './viewQuizMessages';
import NavBar from '../NavBar';
import { buildQuery, convertBreakLines, ssrRequest } from '../../../helpers';
import isMobileUserAgent from '../../../helpers/checkMobileUserAgent';
import isLoggedIn from '../../../helpers/checkAuth';
import history from '../../../history';
import PortraitModeRestrictionModal from '../PortraitModeRestrictionModal/PortraitModeRestrictionModal';
import SkillEvaluationModal from '../../lessonDetails/SkillEvaluationModal/SkillEvaluationModal';

import { substituteVariablesInQuestion } from '../../../helpers/mathQuestions';
import { userRole } from '../../../constants';
import UserPersonalityConfirmationDialog from '../../../components/UserPersonalityConfirmationDialog/UserPersonalityConfirmationDialog';
import ContainerScrollFade from '../../../components/ContainerScrollFade/ContainerScrollFade';

@injectIntl
@withStyles(s)
@reduxForm({
  form: 'viewQuizFormUserName',
  validate: values => {
    const errors = {};

    if (!values || !values.supervisor) {
      errors.supervisor = <FormattedMessage {...messages.required} />;
    }

    if (!values || !values.supervisorOrganization) {
      errors.supervisorOrganization = (
        <FormattedMessage {...messages.required} />
      );
    }

    return errors;
  },
})
@connect(
  state => ({
    auth: state.auth,
    loadingQuiz: state.viewQuiz.loading,
    error: state.viewQuiz.error,
    quiz: state.viewQuiz.quiz,
    quizResult: state.quizResult.quizResult,
    loadingQuizResult: state.quizResult.loading,
    form: state.form.viewQuizForm,
    course: state.courseDetails.course,
    task: state.editTask.task,
    attempts: state.quizResult.attempts,
    lang: state.intl.locale,
  }),
  dispatch =>
    bindActionCreators(
      {
        getResult: quizResultActions.getResult,
        resetResult: quizResultActions.resetResult,
        resetQuiz,
        submit,
      },
      dispatch,
    ),
)
@connect()
export default class ViewQuiz extends React.Component {
  static propTypes = {
    loadingQuiz: PropTypes.bool.isRequired,
    getResult: PropTypes.func.isRequired,
    resetResult: PropTypes.func.isRequired,
    resetQuiz: PropTypes.func.isRequired,
    submit: PropTypes.func.isRequired,
    loadingQuizResult: PropTypes.bool.isRequired,
    query: PropTypes.object, // eslint-disable-line
    error: PropTypes.string,
    lang: PropTypes.string.isRequired,
    intl: intlShape.isRequired,
    course: PropTypes.shape({}),
    quiz: PropTypes.shape({
      _id: PropTypes.string.isRequired,
      timeLimit: PropTypes.number.isRequired,
      currentTime: PropTypes.number,
      timeStart: PropTypes.number,
      timeEnd: PropTypes.number,
      questions: PropTypes.oneOfType([
        PropTypes.arrayOf(
          PropTypes.oneOfType([PropTypes.shape({}), PropTypes.number]),
        ),
        PropTypes.number,
      ]),
    }).isRequired,
    auth: PropTypes.shape({
      user: PropTypes.shape({}),
    }).isRequired,
    task: PropTypes.shape({}),
    quizResult: PropTypes.shape({}).isRequired,
    width: PropTypes.string,
    params: PropTypes.shape({
      courseSlug: PropTypes.string,
    }),
    ...reduxFormPropTypes,
    form: PropTypes.shape({}),
    store: PropTypes.shape({}).isRequired,
  };

  static defaultProps = {
    query: {},
    error: '',
    course: {},
    task: {},
    params: {},
    form: undefined,
    width: undefined,
  };

  static contextTypes = {
    fetch: PropTypes.func,
    intl: intlShape,
    organizationSlug: PropTypes.string,
    whitelabeling: PropTypes.shape({}),
    cloudfrontUrl: PropTypes.string,
  };

  constructor(props) {
    super(props);
    const { course, query } = this.props;
    this.timer = 0;
    this.updateEndDateTimer = null;
    this.menuAnchorEl = null;
    this.unblock = () => null;

    const lessonsAndQuizzes = _((course && course.sections) || [])
      .map('items')
      .flatten()
      .value();

    const quizIndex = _.findIndex(
      lessonsAndQuizzes,
      item => item.item._id === _.get(this, 'props.quiz._id'),
    );

    const nextItem = lessonsAndQuizzes[quizIndex + 1];

    this.state = {
      questionNumber: 0,
      reviewedQuestions: [],
      leftTime: 0,
      timeLine: 100,
      time: '',
      isQuizStart: false,
      isSummaryShow: false,
      questionsText: [],
      transition: <Slide direction="left" />,
      showSnackBarError: false,
      isMenuOpen: false,
      nextItem,
      isAnswerSending: false,
      allowedAttempts: _.get(this.props, 'attempts.allowedAttempts'),
      attempts: _.get(this.props, 'attempts.attempts', 0),
      timeStart: _.get(this.props, 'attempts.timeStart'),
      timeEnd: _.get(this.props, 'attempts.timeEnd'),
      passingQuizError: '',
      showCongratulations: false,
      ignorePortraitMode: false,
      orientation: 'portrait',
      isMobile: isMobileUserAgent(),
      isEvaluationModalOpened:
        _.has(query, 'showEvaluationModal') &&
        _.get(props, 'auth.user.role') !== userRole.ADMIN,
      isUserPersonalityConfirmed: false,
      user: this.props.auth?.user,
    };

    const currentTime = _.get(this.props, 'attempts.currentTime');

    let { timeLimit } = this.props.quiz;

    if (this.state.timeEnd) {
      timeLimit = moment(this.state.timeEnd).diff(moment(), 'milliseconds');
    }

    if (timeLimit > 0 && this.state.timeEnd) {
      const timeDifference = moment
        .utc()
        .diff(moment.utc(currentTime), 'milliseconds');
      const end = moment.utc(this.state.timeEnd).valueOf();
      const start = moment.utc(this.state.timeStart).valueOf();
      const seconds = (end - moment.utc().valueOf() + timeDifference) / 1000;
      this.state.timeLine = Math.ceil(
        ((end - moment.utc().valueOf() + timeDifference) / (end - start)) * 100,
      );
      this.state.leftTime = seconds > 0 ? seconds : 0;
      this.state.time = this.secondsToTime(seconds > 0 ? seconds : 0);
    }

    if (this.state.leftTime <= 0) {
      this.state.timeLine = 100;
      this.state.leftTime = this.props.quiz.timeLimit;
      this.state.time = this.secondsToTime(this.props.quiz.timeLimit);
    }
  }

  componentDidMount() {
    this.props.resetResult();
    if (
      _.has(this.props, 'query.restart') ||
      (this.state.leftTime &&
        moment(this.state.timeEnd).diff(moment(), 'seconds') > 0)
    ) {
      if (this.isSkholeCertifiedExam()) {
        this.props.handleSubmit(this.startTimer);
      } else {
        this.startTimer();
      }
    }

    if (this.state.isMobile) {
      Intercom.boot(this.props.auth.user, this.context.whitelabeling);
    } else {
      Intercom.hideWidget();
    }

    this.updateNavBar();
    this.setScreenOrientationDebounced();
    window.addEventListener('resize', this.updateNavBar);
    window.addEventListener('resize', this.setScreenOrientationDebounced);
  }

  componentWillReceiveProps(nextProps) {
    const stateToHtmlOptions = {
      entityStyleFn: entityStyleFn({
        cloudfrontUrl: this.context.cloudfrontUrl,
      }),
    };
    if (
      typeof this.props.quiz.questions !== typeof nextProps.quiz.questions &&
      _.isArray(nextProps.quiz.questions)
    ) {
      this.setState({
        questionsText: _.map(nextProps.quiz.questions, question => {
          const editorState = createEditorState(question.question);
          const editorStateContent =
            editorState && editorState.getCurrentContent();

          return stateToHTML(editorStateContent, stateToHtmlOptions);
        }),
      });
    }

    if (
      _.get(this, 'props.course._id') &&
      _.get(this, 'props.course._id') === _.get(nextProps, 'course._id') &&
      (_.get(this, 'props.course.progress') !== 100 &&
        _.get(nextProps, 'course.progress')) === 100
    ) {
      this.setState({ showCongratulations: true });
    }

    if (_.get(this, 'props.quiz._id') !== _.get(nextProps, 'quiz._id')) {
      this.handleMenuClose();

      const lessonsAndQuizzes = _(_.get(nextProps, 'course.sections', []))
        .map('items')
        .flatten()
        .value();

      const quizIndex = _.findIndex(
        lessonsAndQuizzes,
        item => item.item._id === _.get(nextProps, 'quiz._id'),
      );

      const nextItem = lessonsAndQuizzes[quizIndex + 1];

      if (this.timer) {
        clearInterval(this.timer);
      }

      const time = nextProps.quiz.timeLimit
        ? this.secondsToTime(nextProps.quiz.timeLimit)
        : '';

      this.setState({
        isEnded: false,
        questionNumber: 0,
        isQuizStart: false,
        nextItem,
        time,
        leftTime: nextProps.quiz.timeLimit ? nextProps.quiz.timeLimit : '',
        showCongratulations: false,
      });
    }
  }

  componentWillUnmount() {
    if (this.updateEndDateTimer) {
      clearInterval(this.updateEndDateTimer);
    }
    if (this.timer) {
      clearInterval(this.timer);
    }
    window.removeEventListener('beforeunload', this.onBeforeUnload);
    window.removeEventListener('resize', this.setScreenOrientationDebounced);
    this.unblock();
  }

  onBeforeUnload = e => {
    const message = this.props.intl.formatMessage(
      messages.beforePageLeaveMessage,
    );
    e.returnValue = message;
    return message;
  };

  getQuestions = async (quizId, data) => {
    const { dispatch } = this.props;

    this.setState({ showSnackBarError: false });

    await dispatch({
      type: startQuiz(quizId, data).types[0],
    });

    try {
      const res = await startQuiz(quizId, data).promise(this.context.fetch);

      const resText = await res.text();

      const json = resText ? JSON.parse(resText) : {};

      if (res.status !== 200) {
        return dispatch({
          error: json && json.message,
          type: startQuiz(quizId, data).types[2],
        });
      }
      const result = {
        status: res.status,
        json,
      };

      await dispatch({
        result,
        type: startQuiz(quizId, data).types[1],
      });

      return new Promise(resolve => {
        const { quiz } = this.props;
        const timeDifference = moment
          .utc()
          .diff(moment.utc(quiz.currentTime), 'milliseconds');

        const end = moment.utc(quiz.timeEnd).valueOf();

        let leftTime = (end - moment.utc().valueOf() + timeDifference) / 1000;
        if (leftTime < 0) {
          leftTime = 0;
        }

        let questionNumber = quiz.lastQuestionId
          ? _.findIndex(
              quiz.questions,
              ({ _id }) => _id === quiz.lastQuestionId,
            )
          : 0;

        if (questionNumber === -1) {
          questionNumber = 0;
        }

        this.setState(
          {
            isQuizStart: true,
            leftTime,
            time: this.secondsToTime(leftTime),
            timeEnd: this.props.quiz.timeEnd,
            timeStart: this.props.quiz.timeStart,
            timeDifference,
            questionNumber,
            showCongratulations: false,
          },
          () => {
            this.scrollQuestion();
            resolve();
          },
        );
      });
    } catch (error) {
      this.setState({ showSnackBarError: true });
      return dispatch({
        error: error && error.message,
        type: startQuiz(quizId, data).types[2],
      });
    }
  };

  getCourse = async () => {
    const { params, store } = this.props;
    const { fetch } = this.context;

    const courseSlug = _.get(params, 'courseSlug');
    if (!courseSlug) {
      return Promise.resolve();
    }

    return ssrRequest({
      store,
      fetch,
      getAction: getCourseBySlug.bind(this, courseSlug),
      context: this.context,
    });
  };

  getResultUrl = () => {
    const { task, course, quiz, lang } = this.props;
    const { organizationSlug } = this.context;
    const { showCongratulations } = this.state;

    return task._id
      ? `/${lang}${organizationSlug ? `/${organizationSlug}` : ''}/tasks/${
          task._id
        }/exams/${quiz._id}/quiz-result?exam`
      : `/${lang}${organizationSlug ? `/${organizationSlug}` : ''}/courses/${
          course.slug
        }/quizzes/${quiz._id}/quiz-result?${
          showCongratulations ? 'showCongratulations' : ''
        }`;
  };

  getPrevQuestion = () => {
    const {
      quiz,
      form,
      course: { _id: courseId },
    } = this.props;
    const questionIndex = this.state.questionNumber;
    const prevQuestion =
      form && form.values ? { ...form.values.questions[questionIndex] } : '';

    if (prevQuestion) {
      prevQuestion.courseId = courseId;
    }

    if (_.get(prevQuestion, 'type') === 'multiple choice') {
      const quizQuestion = _.find(quiz.questions, { _id: prevQuestion._id });
      prevQuestion.answers = _.filter(
        _.map(prevQuestion.answers, (item, i) => {
          if (item === true) {
            return quizQuestion.generalAnswers[i].description;
          }
          return false;
        }),
        item => !!item,
      );
    }

    if (_.get(prevQuestion, 'type') === 'fill in blank') {
      prevQuestion.answers =
        prevQuestion.answers && prevQuestion.answers.trim();
    }
    return prevQuestion;
  };

  setScreenOrientation = () => {
    this.setState({
      orientation:
        window.innerHeight < window.innerWidth ? 'landscape' : 'portrait',
    });
  };

  setScreenOrientationDebounced = _.debounce(this.setScreenOrientation, 100);

  updateNavBar = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  };

  updateQuizEndDate = () => {
    const { quiz, task } = this.props;
    const query = buildQuery({
      taskId: task._id,
    });
    this.context
      .fetch(`/api/quizzes/${quiz._id}/time-span?${query}`)
      .then(res =>
        res.json().then(resJson => {
          if (!res.ok) {
            console.error(resJson);
            return;
          }

          const { endDate, startDate, isEnded, currentTime } = resJson;

          if (isEnded) {
            clearInterval(this.updateEndDateTimer);
            clearInterval(this.timer);
            this.autoSubmitSession().then(() => {
              window.removeEventListener('beforeunload', this.onBeforeUnload);
              this.unblock();
              history.push(this.getResultUrl());
            });
          }

          const timeDifference = moment
            .utc()
            .diff(moment.utc(currentTime), 'milliseconds');

          this.setState({
            isEnded,
            timeEnd: endDate,
            timeStart: startDate,
            timeDifference,
          });
        }),
      )
      .catch(console.error);
  };

  scrollQuestion = () => {
    const { isQuizStart, questionNumber } = this.state;
    const { width } = this.props;

    if (!isQuizStart) {
      return;
    }

    const block = document.getElementById('student-view-of-quiz-content');
    block.scrollTop = width !== 'xs' ? block.scrollHeight : 0;

    if (width === 'xs' || width === 'sm') {
      const currentButton = document.getElementById(
        `view-quiz-question-btn-${questionNumber}`,
      );
      if (!currentButton) {
        return;
      }

      let scrollLeft =
        currentButton.offsetWidth * (questionNumber - 1) +
        (questionNumber - 1) * 10;

      if (questionNumber < 0) {
        scrollLeft = 0;
      }

      currentButton.parentElement.scrollLeft = scrollLeft;
    }
  };

  autoSubmitSession = () => {
    const { quiz, task, course } = this.props;

    const query = buildQuery({
      taskId: _.get(task, '_id'),
      courseId: _.get(course, '_id'),
    });

    return this.context
      .fetch(`/api/quizzes/${quiz._id}/auto-submit-quiz-result?${query}`, {
        method: 'POST',
      })
      .then(() => {
        if (!course || !course._id) {
          return Promise.resolve();
        }

        return this.getCourse();
      })
      .catch(console.error);
  };

  chooseQuestion = (index, isFinish = false) => {
    const {
      quiz,
      getResult,
      form,
      task,
      intl: { formatMessage },
    } = this.props;

    const questionIndex = this.state.questionNumber;
    const prevQuestion = this.getPrevQuestion();

    if (
      (_.get(form, 'values', []) &&
        _.get(form, `values.questions.${questionIndex}.answers`, []) &&
        _.get(form, `values.questions.${questionIndex}.type`, '') &&
        prevQuestion &&
        _.get(prevQuestion, 'answers.length') !== 0) ||
      isFinish === true
    ) {
      this.setState({ isAnswerSending: true, passingQuizError: '' });
      const body = prevQuestion || {};
      body.isFinish = isFinish;
      const query = buildQuery({ taskId: _.get(task, '_id') });
      return this.context
        .fetch(`/api/quizzes/${quiz._id}/quiz-result?${query}`, {
          method: 'POST',
          body: JSON.stringify(body),
        })
        .then(async res => {
          if (!res.ok) {
            const json = await res.json();
            this.setState({
              passingQuizError:
                (json && json.message) || res.message || res.statusText,
              isAnswerSending: false,
            });
          } else if (res.ok) {
            getResult(quiz._id);

            let { reviewedQuestions } = this.state;
            if (_.get(prevQuestion, 'answers.length')) {
              reviewedQuestions = _.remove(
                reviewedQuestions,
                value => value !== questionIndex,
              );
            }
            this.setState(
              {
                questionNumber: index,
                isAnswerSending: false,
                passingQuizError: '',
                isSummaryShow: false,
                reviewedQuestions,
              },
              this.scrollQuestion,
            );
          }
          return res;
        })
        .catch(err => {
          let passingQuizError = err && err.message;

          if (err && err.name === 'TypeError') {
            passingQuizError = formatMessage(messages.connectivityError);
          }

          if (passingQuizError) {
            this.setState({
              passingQuizError,
              isAnswerSending: false,
            });
          }
        });
    }

    return new Promise(resolve => {
      this.setState(
        {
          questionNumber: index,
          isAnswerSending: false,
          isSummaryShow: false,
        },
        () => {
          if (!isFinish) {
            this.scrollQuestion();
          }

          if (isFinish) {
            clearInterval(this.timer);
            clearInterval(this.updateEndDateTimer);
            window.removeEventListener('beforeunload', this.onBeforeUnload);
            this.unblock();
          }
          resolve();
        },
      );
    });
  };

  reviewQuestion = () => {
    const question = this.getPrevQuestion();
    if (!_.get(question, 'answers.length')) {
      this.setState(prevState => ({
        reviewedQuestions: [
          ...prevState.reviewedQuestions,
          prevState.questionNumber,
        ],
      }));
    }
  };

  showSummary = () => {
    this.chooseQuestion(this.state.questionNumber).then(() => {
      this.setState({
        isSummaryShow: true,
      });
    });
  };

  secondsToTime = secs => moment.utc(secs * 1000).format('HH:mm:ss');

  countDown = async () => {
    const { timeDifference, timeEnd, timeStart } = this.state;

    const end = moment.utc(timeEnd).valueOf();
    const start = moment.utc(timeStart).valueOf();
    const seconds = (end - moment.utc().valueOf() + timeDifference) / 1000;
    const timeLine = Math.ceil(
      ((end - moment.utc().valueOf() + timeDifference) / (end - start)) * 100,
    );

    const newState = {
      timeLine,
      time: this.secondsToTime(seconds > 0 ? seconds : 0),
    };

    if (timeLine <= 0) {
      newState.timeLine = 0;
      newState.isEnded = true;
      window.removeEventListener('beforeunload', this.onBeforeUnload);
      this.unblock();
    }

    this.setState(newState);

    if (seconds <= 0) {
      clearInterval(this.timer);
      clearInterval(this.updateEndDateTimer);
      await this.autoSubmitSession();
      history.push(this.getResultUrl());
    }
  };

  startTimer = (data = {}) => {
    const processedData = {
      ...data,
      taskId: _.get(this.props.task, '_id'),
      courseId: _.get(this.props.course, '_id'),
    };

    return this.getQuestions(this.props.quiz._id, processedData).then(() => {
      if (this.state.isQuizStart && this.timer === 0) {
        this.timer = setInterval(this.countDown, 1000);
        this.updateEndDateTimer = setInterval(this.updateQuizEndDate, 10000);
        window.addEventListener('beforeunload', this.onBeforeUnload);
        this.unblock = history.block(() =>
          this.props.intl.formatMessage(messages.beforePageLeaveMessage),
        );
      }
    });
  };

  handleMenuOpen = () => {
    this.setState({ isMenuOpen: true });
  };

  handleMenuClose = () => {
    this.setState({ isMenuOpen: false });
  };

  finishQuiz = async () => {
    const { questionNumber, isEnded } = this.state;

    if (isEnded) {
      await this.autoSubmitSession();
      window.removeEventListener('beforeunload', this.onBeforeUnload);
      this.unblock();
      history.push(this.getResultUrl());
      return;
    }

    this.chooseQuestion(questionNumber, true)
      .then(() => {
        if (!this.props.course || !this.props.course._id) {
          return null;
        }

        return this.getCourse();
      })
      .then(() => {
        window.removeEventListener('beforeunload', this.onBeforeUnload);
        this.unblock();
        history.push(this.getResultUrl());
      });
  };

  isSkholeCertifiedExam = () =>
    !!_.get(this.props.task, '_id') &&
    !!_.get(this.props.quiz, 'isSkholeCertified');

  closeEvaluationModal = () => {
    this.setState({
      isEvaluationModalOpened: false,
    });
  };

  confirmUserPersonality = () =>
    this.setState({ isUserPersonalityConfirmed: true });

  render() {
    const {
      loadingQuiz,
      quiz,
      quizResult,
      form,
      course,
      intl: { formatMessage },
      task,
      auth,
      error,
      handleSubmit,
    } = this.props;

    const {
      questionNumber,
      reviewedQuestions,
      time,
      timeLine,
      isQuizStart,
      isSummaryShow,
      questionsText,
      transition,
      showSnackBarError,
      isMenuOpen,
      nextItem,
      isAnswerSending,
      allowedAttempts,
      attempts,
      passingQuizError,
      isEnded,
      orientation,
      isMobile,
      ignorePortraitMode,
      isEvaluationModalOpened,
      isUserPersonalityConfirmed,
    } = this.state;

    const isExam = _.has(this.props, 'task._id');

    let currentQuiz;

    _.each(course.sections, section => {
      _.each(section.items, item => {
        if (item.itemType === 'Quiz' && item.item._id === quiz._id) {
          currentQuiz = item;
        }
      });
    });

    const nextUrl =
      nextItem &&
      (nextItem.itemType === 'Lesson'
        ? `lessons/${nextItem.item.slug}`
        : `quizzes/${nextItem.item._id}`);

    let questionText;

    if (questionsText.length > 0) {
      questionText = questionsText[questionNumber];
    }

    let mathQuestionFormula = '';
    let mathQuestionAllowedDecimalsHint = '';
    if (_.get(quiz, `questions[${questionNumber}].type`) === 'basic math') {
      questionText = substituteVariablesInQuestion(
        questionText,
        _.get(quiz, `questions[${questionNumber}].generatedVariables`),
      );
      mathQuestionFormula = _.get(
        quiz,
        `questions[${questionNumber}].substitutedFormulaMathQuestion`,
      );
      const allowedDecimals = _.get(
        quiz,
        `questions[${questionNumber}].allowedDecimals`,
      );
      if (allowedDecimals === 'not allowed') {
        mathQuestionAllowedDecimalsHint = (
          <FormattedMessage {...messages.mathQuestionNotAllowedDecimalsHint} />
        );
      } else if (allowedDecimals !== 'no preference') {
        mathQuestionAllowedDecimalsHint = (
          <FormattedMessage
            {...messages.mathQuestionAllowedDecimalsHint}
            values={{ allowedDecimals: parseInt(allowedDecimals, 10) }}
          />
        );
      }
    }

    let answeredQuestions;

    if (quizResult) {
      answeredQuestions = quizResult.answers;
    }
    const questionsBlock =
      isQuizStart && _.isArray(quiz.questions)
        ? quiz.questions
        : _.times(quiz.questions, Number);

    const isLastQuestion =
      quiz.questions && questionNumber === quiz.questions.length - 1;

    const showQuizQuestions = () => (
      <QuestionsForm
        questionNumber={questionNumber}
        chooseQuestion={this.chooseQuestion}
        answeredQuestions={answeredQuestions}
        finishQuiz={this.finishQuiz}
        isAnswerSending={isAnswerSending}
        passingQuizError={passingQuizError}
      />
    );

    const maxAttempts = allowedAttempts || task.maxQuizTries + 1;
    const isLandscapeOrientation = isMobile && orientation === 'landscape';

    return (
      <div className={s.root}>
        <LoadingBar className={s.loadingBar} />
        {isLoggedIn(auth) && !!course._id && (
          <SkillEvaluationModal
            isOpen={isEvaluationModalOpened}
            onSave={this.closeEvaluationModal}
            courseId={course._id}
          />
        )}
        <PortraitModeRestrictionModal
          isOpen={isLandscapeOrientation && !ignorePortraitMode}
          onClose={() => {
            this.setState({ ignorePortraitMode: true });
          }}
        />
        <div className={s.appFrame}>
          <NavBar
            id="quiz-navbar"
            disableGutters={!isMenuOpen}
            backTooltipTitle={formatMessage(messages.backToTitle, {
              name: isExam ? 'tasks' : course.name,
            })}
            backIconRoute={isExam ? `/tasks` : `/courses/${course.slug}`}
            mainTitle={
              isExam
                ? formatMessage(messages.examNameLabel, {
                    name: quiz.name,
                  })
                : quiz.name
            }
            menuProps={{
              isVisible: !isExam,
              onClick: isMenuOpen ? this.handleMenuClose : this.handleMenuOpen,
              buttonRef: node => {
                this.menuAnchorEl = node;
              },
            }}
          />
          {loadingQuiz && (
            <div className={s.loadingWrapper}>
              <CircularProgressLoader />
            </div>
          )}
          <div className={s.content} id="student-view-of-quiz">
            {!_.isArray(quiz.questions) && quiz.questions === 0 && (
              <span className={s.noQuestionsText}>
                <FormattedMessage {...messages.noQuestionsText} />
              </span>
            )}
            {((!_.isArray(quiz.questions) && quiz.questions > 0) ||
              (_.isArray(quiz.questions) && !_.isEmpty(quiz.questions))) && (
              <div
                className={s.quizContentContainer}
                id="student-view-of-quiz-content-container"
              >
                <div
                  className={s.quizContent}
                  id="student-view-of-quiz-content"
                >
                  <ContainerScrollFade icon={<ArrowDownwardIcon />} />
                  <div className={s.timeBlock}>
                    <h4 className={s.marginRight}>
                      <FormattedMessage {...messages.timeLimit} /> {time}
                    </h4>
                    {isExam && maxAttempts && maxAttempts > 1 && (
                      <h4 className={s.marginRight}>
                        <FormattedMessage {...messages.attemptsTitle} />
                        &nbsp;
                        {`${attempts}/${maxAttempts}`}
                      </h4>
                    )}
                    {isExam && (
                      <h4 className={s.marginRight}>
                        <FormattedMessage {...messages.dueDateTitle} /> &nbsp;
                        {task.endDate &&
                          moment(task.endDate).format('YYYY-MM-DD HH:mm')}
                      </h4>
                    )}
                    {!isSummaryShow && !isQuizStart && !isEnded && (
                      <Button
                        data-test-id="hO82Vhk8Y4cTvBu2qo_Hm"
                        id="quiz-start-btn"
                        variant="contained"
                        size="large"
                        color="primary"
                        className={classNames(s.button, s.startBtn)}
                        onClick={
                          this.isSkholeCertifiedExam()
                            ? handleSubmit(this.startTimer)
                            : () => this.startTimer()
                        }
                        disabled={loadingQuiz}
                      >
                        {isExam &&
                          !!this.state.leftTime &&
                          moment(this.state.timeEnd).diff(moment(), 'seconds') >
                            0 && (
                            <FormattedMessage
                              {...messages.resumeExamBtnLabel}
                            />
                          )}
                        {isExam &&
                          !(
                            !!this.state.leftTime &&
                            moment(this.state.timeEnd).diff(
                              moment(),
                              'seconds',
                            ) > 0
                          ) && (
                            <FormattedMessage {...messages.startExamBtnLabel} />
                          )}
                        {!isExam && (
                          <FormattedMessage {...messages.startQuizBtnLabel} />
                        )}
                      </Button>
                    )}
                  </div>
                  <div>
                    <LinearProgress
                      variant="determinate"
                      value={timeLine}
                      className={s.timeLine}
                    />
                  </div>
                  {isSummaryShow && (
                    <div>
                      <h3 className={s.summary}>
                        <FormattedMessage {...messages.summaryTitle} />
                      </h3>
                      <span className={s.marginRight}>
                        {
                          _.filter(
                            answeredQuestions,
                            item => item.values !== undefined,
                          ).length
                        }
                      </span>
                      <span className={s.marginRight}>
                        <FormattedMessage {...messages.ofText} />
                      </span>
                      <span className={s.marginRight}>
                        {quiz.questions.length}
                      </span>
                      <span className={s.marginRight}>
                        <FormattedMessage {...messages.questionsText} />
                      </span>
                      <span className={s.marginRight}>
                        <FormattedMessage {...messages.completedText} />
                      </span>
                      <br />
                      <span className={s.questions}>
                        <FormattedMessage {...messages.questionsTitle} />
                      </span>
                    </div>
                  )}
                  <Paper className={s.questionsBlock}>
                    {questionsBlock.map((item, index) => {
                      const key = index;
                      let isCorrect;
                      if (
                        quiz.quizMode === 'Check' &&
                        quiz.showCorrectAnswers &&
                        _.isObject(item)
                      ) {
                        const answeredQuestion = _.find(
                          _.get(quizResult, 'answers', []),
                          {
                            question: item._id,
                          },
                        );
                        isCorrect = _.get(answeredQuestion, 'isCorrect');
                      }
                      return (
                        <Button
                          data-test-id="43ElD_tbhu4H2_o9IN6U3"
                          key={key}
                          className={classNames({
                            [s.numberBlock]: true,
                            [s.currentQuestion]: index === questionNumber,
                            [s.reviewQuestion]:
                              _.indexOf(reviewedQuestions, index) !== -1,
                            [s.answeredQuestion]:
                              (quiz.quizMode === 'Exam' ||
                                !quiz.showCorrectAnswers) &&
                              form &&
                              _.get(form, 'values', []) &&
                              _.get(
                                form.values,
                                `questions.${index}.answers`,
                                [],
                              ) &&
                              _.get(
                                form.values,
                                `questions.${index}.type`,
                                '',
                              ) &&
                              ((_.get(
                                form.values.questions[index],
                                'answers.length',
                                0,
                              ) !== 0 &&
                                form.values.questions[index].type !==
                                  'multiple choice') ||
                                (form.values.questions[index].type ===
                                  'multiple choice' &&
                                  _.indexOf(
                                    form.values.questions[index].answers,
                                    true,
                                  ) !== -1)) &&
                              index !== questionNumber,
                            [s.rightAnswered]:
                              isCorrect && index !== questionNumber,
                            [s.wrongAnswered]:
                              isCorrect === false && index !== questionNumber,
                          })}
                          id={`view-quiz-question-btn-${index}`}
                          onClick={() => this.chooseQuestion(index)}
                          disabled={!isQuizStart || isAnswerSending || isEnded}
                        >
                          {index + 1}
                        </Button>
                      );
                    })}
                  </Paper>
                  {!isQuizStart && quiz.description && (
                    <Paper className={s.descriptionBlock}>
                      <Typography variant="body2">
                        <Interweave
                          content={convertBreakLines(quiz.description)}
                        />
                      </Typography>
                    </Paper>
                  )}
                  {!isQuizStart && this.isSkholeCertifiedExam() && (
                    <Paper className={s.descriptionBlock}>
                      <Typography variant="body2" color="secondary">
                        <FormattedHTMLMessage
                          {...messages.skholeCertifiedExamInfo}
                        />
                      </Typography>
                    </Paper>
                  )}
                  {!isQuizStart && this.isSkholeCertifiedExam() && (
                    <Paper className={s.descriptionBlock}>
                      <Typography variant="body2">
                        <FormattedMessage
                          {...messages.pleaseEnterNameAndOrganization}
                        />
                      </Typography>
                      <form onSubmit={handleSubmit(this.startTimer)}>
                        <div>
                          <Field
                            name="supervisor"
                            type="text"
                            component={TextField}
                            margin="dense"
                            label={formatMessage(messages.supervisorName)}
                          />
                        </div>
                        <div>
                          <Field
                            name="supervisorOrganization"
                            type="text"
                            component={TextField}
                            margin="dense"
                            label={formatMessage(
                              messages.supervisorOrganization,
                            )}
                          />
                        </div>
                      </form>
                    </Paper>
                  )}
                  {showSnackBarError && (
                    <SnackbarContent
                      className={s.snackbar}
                      message={quiz.error}
                      TransitionComponent={transition}
                    />
                  )}
                  {error && (
                    <SnackbarContent
                      className={s.snackbar}
                      message={error}
                      TransitionComponent={transition}
                    />
                  )}
                  {isSummaryShow && (
                    <div className={classNames(s.summaryBtnWrap, s.mobileOnly)}>
                      <Button
                        data-test-id="Ca5V3_1GrV09t3gEbw-9s"
                        variant="outlined"
                        color="primary"
                        size="large"
                        className={classNames({
                          [s.button]: true,
                          [s.marginTop]: true,
                          [s.summaryFinishBtn]: true,
                        })}
                        onClick={() => {
                          this.setState({
                            isSummaryShow: false,
                          });
                        }}
                      >
                        <FormattedMessage {...messages.back} />
                      </Button>
                      <Button
                        data-test-id="ntILRAc_EfLY4gsgNhaxu"
                        variant="contained"
                        size="large"
                        color="primary"
                        className={classNames({
                          [s.marginTop]: true,
                          [s.summaryFinishBtn]: true,
                        })}
                        onClick={() => this.finishQuiz()}
                        disabled={isAnswerSending}
                      >
                        <FormattedMessage {...messages.finishBtnLabel} />
                      </Button>
                    </div>
                  )}
                  {isEnded && (
                    <div>
                      <FormattedHTMLMessage {...messages.ended} />
                    </div>
                  )}
                  {isQuizStart && !isEnded && (
                    <div
                      className={classNames(s.contentBlock, {
                        [s.hidden]: isSummaryShow,
                      })}
                    >
                      <div className={s.buttonsBlock}>
                        <Button
                          data-test-id="0ppUeVtMzH6QcsgOJZc8G"
                          id="quiz-review-btn"
                          variant="contained"
                          size="large"
                          className={classNames(s.button, s.reviewBtn)}
                          color="primary"
                          onClick={this.reviewQuestion}
                          disableRipple
                        >
                          <FormattedMessage {...messages.reviewBtnLabel} />
                        </Button>
                        <Button
                          data-test-id="OpRfv0q7P4_JlG7x3P0Nc"
                          id="quiz-summary-btn"
                          variant="contained"
                          size="large"
                          className={s.button}
                          color="primary"
                          onClick={this.showSummary}
                          disabled={isAnswerSending}
                          disableRipple
                        >
                          <FormattedMessage {...messages.summaryTitle} />
                        </Button>
                      </div>
                      <div className={s.numberOfQuestion}>
                        <span className={s.marginRight}>
                          <FormattedMessage {...messages.questionText} />
                        </span>
                        <span className={s.bold}>{questionNumber + 1}</span>
                        <span className={s.marginRight}>
                          <FormattedMessage {...messages.ofText} />
                        </span>
                        <span className={s.bold}>{quiz.questions.length}</span>
                      </div>
                      <div className={s.numberOfQuestion}>
                        <span className={s.bold}>{questionNumber + 1}.</span>
                        <span className={s.bold}>
                          <FormattedMessage {...messages.questionText} />
                        </span>
                      </div>
                      <Interweave
                        content={`<div class="notranslate" data-no-translate>${questionText}</div>`}
                      />
                      {mathQuestionFormula &&
                        mathQuestionAllowedDecimalsHint && (
                          <p className={s.mathHint}>
                            {mathQuestionAllowedDecimalsHint}
                          </p>
                        )}
                      {showQuizQuestions()}
                    </div>
                  )}
                </div>
              </div>
            )}
            {!isSummaryShow && (
              <div className={classNames(s.btnsBlock, s.mobileOnly)}>
                {isQuizStart && !isLastQuestion && (
                  <Button
                    data-test-id="IzP8qy3Fzpf-j8LW-CsDz"
                    variant="contained"
                    color="primary"
                    size="large"
                    className={classNames(s.goToBtn)}
                    onClick={() => this.chooseQuestion(questionNumber + 1)}
                    disabled={isAnswerSending || isEnded}
                  >
                    <FormattedMessage {...messages.nextBtnLabel} />
                  </Button>
                )}
                {isQuizStart && isLastQuestion && !isSummaryShow && (
                  <Button
                    data-test-id="IUzY1m57_cH7dJaTVjmAl"
                    variant="contained"
                    color="primary"
                    size="large"
                    className={classNames(s.goToBtn)}
                    onClick={this.showSummary}
                    disabled={isAnswerSending}
                  >
                    <FormattedMessage {...messages.summaryTitle} />
                  </Button>
                )}
                {!isExam && nextItem && currentQuiz && currentQuiz.isCompleted && (
                  <Button
                    variant="outlined"
                    color="primary"
                    to={`/courses/${course.slug}/${nextUrl}`}
                    size="large"
                    component={Link}
                    className={s.goToBtn}
                  >
                    <FormattedMessage
                      {...messages.goToBtnLabel}
                      values={{
                        name: `${_.get(nextItem, 'item.name', '')}`,
                      }}
                    />
                    <NextIcon />
                  </Button>
                )}
              </div>
            )}
          </div>
          <SectionItemNavigationMenu
            isMenuOpen={isMenuOpen}
            menuAnchorEl={this.menuAnchorEl}
            handleMenuClose={this.handleMenuClose}
            course={course}
            currentItemId={quiz._id}
          />
        </div>
        {!isSummaryShow && (
          <div className={classNames(s.btnsBlock, s.hiddenOnMobile)}>
            {!isExam && nextItem && currentQuiz && currentQuiz.isCompleted && (
              <Button
                variant="outlined"
                color="primary"
                to={`/courses/${course.slug}/${nextUrl}`}
                size="large"
                component={Link}
                className={s.goToBtn}
              >
                <FormattedMessage
                  {...messages.goToBtnLabel}
                  values={{
                    name: `${_.get(nextItem, 'item.name', '')}`,
                  }}
                />
                <NextIcon />
              </Button>
            )}
            {isQuizStart && !isLastQuestion && (
              <Button
                data-test-id="Lvufpy7djGTNopq05tV17"
                variant="contained"
                color="primary"
                size="large"
                className={classNames(s.goToBtn)}
                onClick={() => this.chooseQuestion(questionNumber + 1)}
                disabled={isAnswerSending || isEnded}
              >
                <FormattedMessage {...messages.nextBtnLabel} />
              </Button>
            )}
            {isQuizStart && isLastQuestion && !isSummaryShow && !isEnded && (
              <Button
                data-test-id="vLO5LW3Er59OWun55PQuG"
                variant="contained"
                size="large"
                className={classNames(s.goToBtn)}
                color="primary"
                onClick={this.showSummary}
                disabled={isAnswerSending}
              >
                <FormattedMessage {...messages.summaryTitle} />
              </Button>
            )}
          </div>
        )}
        {isSummaryShow && (
          <div className={classNames(s.summaryBtnWrap, s.hiddenOnMobile)}>
            <Button
              data-test-id="y8HvrAGppekcuKORkIcRA"
              variant="outlined"
              color="primary"
              size="large"
              className={classNames({
                [s.button]: true,
                [s.marginTop]: true,
                [s.summaryFinishBtn]: true,
              })}
              onClick={() => {
                this.setState({
                  isSummaryShow: false,
                });
              }}
            >
              <FormattedMessage {...messages.back} />
            </Button>
            <Button
              data-test-id="Wwwu8A7amEI8W_qfpWE4k"
              id="quiz-finish-btn"
              variant="contained"
              size="large"
              color="primary"
              className={classNames({
                [s.marginTop]: true,
                [s.summaryFinishBtn]: true,
              })}
              onClick={() => this.finishQuiz()}
              disabled={isAnswerSending || isEnded}
            >
              <FormattedMessage {...messages.finishBtnLabel} />
            </Button>
          </div>
        )}
        <UserPersonalityConfirmationDialog
          isShown={
            !isUserPersonalityConfirmed &&
            !isSummaryShow &&
            !isQuizStart &&
            !isEnded &&
            this.isSkholeCertifiedExam()
          }
          handleSubmit={this.confirmUserPersonality}
          title={
            <FormattedMessage
              {...messages.personalityConfirmationTitle}
              values={{
                firstName: this.state?.user?.firstName,
                lastName: this.state?.user?.lastName,
              }}
            />
          }
          confirmBtnLabel={
            <FormattedMessage
              {...messages.personalityConfirmationConfirmText}
            />
          }
          logoutBtnLabel={
            <FormattedMessage
              {...messages.personalityConfirmationCancelTitle}
            />
          }
        />
      </div>
    );
  }
}
